module.exports = __webpack_public_path__ + "img/header.055d9c9b.png";